export enum EntityType {
  INVALID = "INVALID",
  CASE = "CASE",
  INVOICE = "INVOICE",
  PAYMENT = "PAYMENT",
  OFFICE = "OFFICE",
  CASE_FILE = "CASE_FILE",
  ORDER_FILE = "ORDER_FILE",
}
